module.exports = __webpack_public_path__ + "static/media/ZESPOL.77f89bfe.png";